<template>
  <div id="app">
    <header class="page-header">
      <div class="container">
        <div class="logo">
          <img
            src="./assets/logo.png"
            alt="Caldwell UNC Health Care"
          >
        </div>
        <a
          class="return"
          href="http://caldwellmemorial.org/"
        >Return to Caldwell UNC Health Care</a>
      </div>
    </header>
    <main role="main">
      <div class="container">
        <transition name="fade">
          <router-view />
        </transition>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style lang="scss">
body {
  background: #fff;
}

.page-header {
  background: #286193;
  color: #fff;
  padding: 1rem 0;
  @media screen and (min-width: 768px) {
    padding: 1rem;
  }

  .container {
    align-items: center;
    display: flex;
  }

  .logo {
    margin-right: 1rem;
  }

  a.return {
    color: inherit;
    font-size: .75rem;
    line-height: 1;
    margin-left: auto;
    text-align: center;
    @media screen and (min-width: 768px) {
      font-size: 1rem;
    }
  }
}

main {
  padding: 1rem 0;
  @media screen and (min-height: 768px) {
    padding: 3rem 0;
  }
}

h1 {
  font-size: 1.5rem;
  letter-spacing: -1px;
  margin-bottom: 1rem;
  @media screen and (min-height: 768px) {
    font-size: 2rem;
    margin-bottom: 2rem;
  }
}

h2 {
  font-size: 1.4rem;
  margin-bottom: 1rem;
  @media screen and (min-height: 768px) {
    font-size: 1.75rem;
  }
}

img {
  max-width: 100%;
}

.cta-box, .cta2-box {
  background: #286193;
  box-shadow: 0 5px 4px rgba(0, 0, 0, .2);
  color: #fff;
  padding: 2rem 1rem 2rem;
  position: relative;
  @media screen and (min-width: 768px) {
    padding: 3.5rem 1.25rem 2rem;
  }

  &::before {
    border: 15px solid rgba(136, 183, 213, 0);
    border-top-color: #fff;
    content: '';
    left: 2rem;
    pointer-events: none;
    position: absolute;
    top: 0;
    @media screen and (min-width: 768px) {
      border-width: 30px;
    }
  }

  a {
    color: inherit;
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }

  b {
    border-bottom: 1px solid #aaa;
    display: block;
    font-size: 1.4rem;
    margin-bottom: 1rem;
    padding-bottom: .4rem;
  }
}

.cta2-box {
  background: #edebeb;
  color: inherit;
  margin-bottom: 2rem;
  margin-top: 1rem;

  b {
    border-bottom: 1px solid #aaa;
    display: block;
    font-size: 1.4rem;
    margin-bottom: 1rem;
    padding-bottom: .4rem;
  }
}

.cta-box-tail {
  background: #ffffcc;
  box-shadow: 0 5px 4px rgba(0, 0, 0, .2);
  color: #000;
  margin-bottom: 1rem;
  padding: 2rem 1rem 2rem;
  position: relative;
  @media screen and (min-width: 768px) {
    margin-bottom: 3rem;
    padding: 2rem 1.25rem;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .25s ease;
}

.fade-enter, .fade-leave-active {
  opacity: 0
}
</style>
